const volcanes = {
  fieldCardSecurityCode: 'Código de Seguridad',
};

module.exports = volcanes;
